export enum OPTION_CONSTANTS {
  SELECT_DATE = 'Select date',
  SELECT_ROOM = 'Select room',
  SELECT_OPTIONS = 'Select Options',
  SELECT_ROOM_QUANTITY = 'Select room & quantity',
  SELECT_TIME_SLOT = 'Select time slot',
  COMPLETE_MAILBOX = 'Please complete the Mail Box Info from your account profile to be able to add to cart this option',
  COMPLETE_FORM = 'Complete the form now',
  ADD_EXTRA_SERVICE = '* You can add extra services and products only for the days you booked',
  ADD_EXTRA_PRODUCTS = '* You can buy products & services only for the current day',
  AVAILABLE_DATE_AND_SLOTS = 'Available Date & Time Slots',
  AVAILABLE_DATE = 'Available Date',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  AVAILABLE_ROOM = 'Select room',
  AVAILABLE_SLOTS = 'Available time slots',
  SELECTED_DAYS = 'Selected Days',
  ADD_EXTRA_TIME = '* You can buy products & services only for the booked days',
  IN_ORDER_TO_CONFIRM = '** In order to confirm your selection you need to click “Continue”',
}

export const getOptionStep = (step: number, text) => {
  return `Step ${step}. ${text}`
}

export enum OPTION_TYPE_CONSTANTS {
  FREE = 'free',
  FIXED = 'fixed',
  MONTH = 'month',
  SLOT = 'slot',
  SLOT_QUANTITY = 'slot_quantity',
  MEDIUM_TERM = 'medium_term',
  SELECT_FIXED = 'selected_fixed',
  SLOT_EXTENSION = 'slot_extension',
  DAY = 'day',
  PACKAGE_EXTENSION = 'package_extension',
}
